import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withSnackbar } from 'notistack';
import { get } from 'lodash';

import { SnackMessage } from './SnackMessages/SnackMessages';
import { NotificationTypes, removeNotification } from '../../actions/notifications';
import { AlertMessage } from './AlertMessage/AlertMessage';

function Notifications({ enqueueSnackbar }) {
    const [displayed, changeDisplayed] = React.useState([]);
    const dispatch = useDispatch();
    const notifications = useSelector((state) => state.notifications || []);

    const storeDisplayed = (key) => {
        changeDisplayed([...displayed, key]);
    };

    const wizardStep = useSelector((state) => get(state, 'wizard.wizardStep', 0));
    const currentLegId = useSelector((state) => get(state, 'screen.currentLeg', 0));
    const { modalType } = useSelector((state) => get(state, 'modal'));
    const isNavRouteStep = wizardStep === 3;

    notifications.forEach(({ message, key, variant, details, callback, onDismiss, props }) => {
        const { legId } = props || {};
        setTimeout(() => {
            if (displayed.indexOf(key) > -1) {
                return;
            }
            if (variant === NotificationTypes.ALERT && (legId !== currentLegId || !isNavRouteStep || modalType)) {
                return;
            }
            // Display notification using notistack
            enqueueSnackbar(message, {
                persist: variant === NotificationTypes.ERROR || variant === NotificationTypes.ALERT,
                autoHideDuration: 5000,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                },
                preventDuplicate: true,
                content: (id) =>
                    variant === NotificationTypes.ALERT ? (
                        <AlertMessage id={id} message={message} callback={callback} onDismiss={onDismiss} variant={variant} />
                    ) : (
                        <SnackMessage id={id} message={message} variant={variant} details={details} />
                    ),
            });
            // Add notification's key to the local state
            storeDisplayed(key);
            // Dispatch action to remove the notification from the redux store
            dispatch(removeNotification(key));
        }, 1);
    });

    return null;
}

const withSnackbarNotifications = withSnackbar(Notifications);

export { withSnackbarNotifications as Notifications };
